/**
* Content Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Plyr from 'plyr';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'content-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.content-slider.splide' ).each( function( index, slide ) {
        const splide = new Splide( slide, {
          type: 'slide',
          perPage: 2,
          perMove: 1,
          gap: '1rem',
          pagination: false,
          drag: false,
          live: true,
          breakpoints: {
            1269: {
              perPage: 1,
            },
          },
        } );

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            arrows: isOverflow,
          };
        } );

        splide.on( 'visible', function( e ) {
          $( e.slide ).find( '.splide-slide' ).attr( 'tabindex', '0' );
        } );

        splide.on( 'hidden', function( e ) {
          $( e.slide ).find( '.splide-slide' ).removeAttr( 'tabindex' );
        } );

        splide.mount();
      } );
      $( '.content-slider .popup-button' ).magnificPopup( {
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-slider', COMPONENT );
} )( app );
